export var Client;
(function (Client) {
    Client[Client["VivacityLabs"] = 1] = "VivacityLabs";
    Client[Client["IntelligentPlay"] = 2] = "IntelligentPlay";
    Client[Client["FieldTurf"] = 3] = "FieldTurf";
})(Client || (Client = {}));
//# sourceMappingURL=client.enum.js.map